import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'

export const assetFragment = gql`
  fragment assetFragment on Asset {
    _id
    url
    title
    subtitle
    thumbUrl
    mediumUrl
    largeUrl
    type
  }
`

export const taskRemarksActivityFragment = gql`
  fragment taskRemarksActivityFragment on Activity {
    _id
    activity
    by {
      _id
      profile {
        _id
        name
        picture
      }
    }
    updatedAt
    isDeleted
  }
`

export const taskStatusActionConfigFragment = gql`
  fragment taskStatusActionConfigFragment on TaskStatusActionConfig {
    _id
    status
    actionHookId
    parameters
    actionHook {
      id
      name
      description
      parameterSchema
    }
  }
`

export const taskTasksFragment = gql`
  fragment taskTasksFragment on Task {
    _id
    name
    code
    remarks
    status
    startDate
    endDate
    timeSpent
    tags
    description
    project {
      _id
      code
      name
      status
      timeSpent
    }
    workOrder {
      _id
      code
      status
      product {
        _id
        code
      }
    }
    members {
      _id
      profile {
        _id
        name
        picture
        email
      }
    }
    remarksActivity {
      ...taskRemarksActivityFragment
    }

    assets {
      ...assetFragment
    }
    percentageComplete
    subTasks {
      _id
      code
      name
      status
      startDate
      endDate
      timeSpent
    }
    parentTask {
      _id
    }
    statusActions {
      ...taskStatusActionConfigFragment
    }
  }
  ${taskStatusActionConfigFragment}
`

export const subTaskFragment = gql`
  fragment subTaskFragment on Task {
    _id
    subTasks {
      ...taskTasksFragment
    }
  }
`

export const subTaskQuery = gql`
  query singleTask($filter: JSON) {
    singleTask(filter: $filter) {
      ...subTaskFragment
    }
  }
  ${taskRemarksActivityFragment}
  ${subTaskFragment}
  ${taskTasksFragment}
  ${assetFragment}
`

export const taskDocumentFragment = gql`
  fragment taskDocumentFragment on Task {
    ...taskTasksFragment
  }
  ${taskRemarksActivityFragment}
  ${taskTasksFragment}
  ${assetFragment}
`

export const taskListFragment = gql`
  fragment taskListFragment on Task {
    _id
    name
    code
    tags
    remarks
    status
    timeSpent
    createdAt
    remarksActivity {
      ...taskRemarksActivityFragment
    }
    statusActions {
      ...taskStatusActionConfigFragment
    }
    assets {
      ...assetFragment
    }
  }
  ${taskRemarksActivityFragment}
  ${taskStatusActionConfigFragment}
  ${assetFragment}
`

export const taskDocumentQueries = buildGraphqlQuery('Task', taskDocumentFragment, ['remarksActivity'])
